export default defineComponent({
  auth: false // this page does not require authentication
});